module.exports = __webpack_public_path__ + "img/loading.8523e814.gif";